import React, { useState } from "react";
import styled from "styled-components";
import shape from "../assets/Shape.svg";

function FaqItem({ key, faq_Qs, faq_Ans1, faq_Ans2, faq_Ans3, ind }) {
  const [clicked, setClicked] = useState(false);

  const toggleFaq = (ind) => {
    if (clicked === ind) {
      return setClicked(false);
    }

    setClicked(ind);
  };
  return (
    <FaqWrapper>
      <div className="faq_wrapper">
        <div onClick={() => toggleFaq(ind)} key={key} className="faq_question">
          <span className="faq_question_text sub_text">{faq_Qs}</span>
          <span className="faq_question_icon sub_text">
            <img src={shape} alt="arrow" />
          </span>
        </div>
        {clicked === ind ? (
          <div className="faq_answer">
            <h3 className="faq_answer_text">{faq_Ans1}</h3>
            <h3 className="faq_answer_text">{faq_Ans2}</h3>
            <h3 className="faq_answer_text">{faq_Ans3}</h3>
          </div>
        ) : null}
      </div>
    </FaqWrapper>
  );
}
const FaqWrapper = styled.div`
  @media (max-width: 768px) {
    .faq_wrapper {
      width: 100% !important;
      padding: 0 20px;
      margin: auto;
    }
    .faq_answer {
      padding: 22px 22px !important;
      background: #e5edfc;
    }
  }
  .faq_question {
    display: flex;
    flex-direction: row;
  }

  .faq_question {
    border-bottom: 1px solid #2323231c;
    cursor: pointer;
  }
  .faq_question_text {
    color: #232323;
    font-size: 20px;
    padding: 35px 0px;
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    align-items: center;
  }
  .faq_question_icon {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .faq_answer {
    background: #e5edfc;
    h3 {
      font-size: 18px;
      font-weight: 500;
      background: #e5edfc;
      padding: 18px;
      font-family: "Manrope Medium";
      line-height: 32px;
    }
  }
  .faq_answer_text {
  }
`;
export default FaqItem;
